import en from 'features/home/localization/homeScreenStrings.en';

export default {
  en,
};
